<app-base-dialog
  [title]="data.titleTemplateRef ?? titleRef"
  [saveBtnTextCodeOrTemplate]="data.submitBtn | translate"
  (save)="dialogRef.close(true)"
  [cancelBtnTextCode]="data.cancelBtn | translate"
  (closeDialog)="dialogRef.close(false)">
  @if (data.ignoreContentHtmlEscaping) {
    <div [class.whitespace-pre-line]="data.displayPlainText">{{ data.content }}</div>
  } @else {
    <div [innerHTML]="data.content"></div>
  }
</app-base-dialog>

<ng-template #titleRef>
  @if (data.isDeleteDialog) {
    <i class="fa-regular fa-trash mr-1"></i>
  }

  <span>{{ data.title }}</span>
</ng-template>
